import { render, staticRenderFns } from "./shipmentCharges.vue?vue&type=template&id=ba906324&scoped=true"
import script from "./shipmentCharges.vue?vue&type=script&lang=js"
export * from "./shipmentCharges.vue?vue&type=script&lang=js"
import style0 from "./shipmentCharges.vue?vue&type=style&index=0&id=ba906324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba906324",
  null
  
)

export default component.exports